<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add EBox User">
      <div class="row">
        <div class="col-md-6 form-group">
          User
          <div v-if="this.type == 'export'">
           <b-form-file
           accept=".xlsx"
            v-model="documentExcel"
            id="fileinput"
            class="form-control mt-2"
            type="file"

          ></b-form-file>
          </div>
          <div v-else>
            <input class="form-control mt-2" v-model="number" type="number" @keyup="getUsers"/>
          <div  class="mt-3">
            <ul v-for="(users, index) in users"
              :key="index"
              >
              <li ><button @click="getUser(users.id)" class="border-0 bg-transparent">{{users.name}}</button></li>
            </ul>
            </div>
          </div>
         
           <div v-if="userEmpty" style="color: red">
            User is required
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="save()"
          >Save</b-button
        >
      </div>
    </base-block>
            <!-- Loader -->
        <b-overlay
          :show="loader"
          no-wrap
          blur="2px"
          opacity="0.60"
          class="position-fixed"
        >
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
        <!-- End Loader -->
  </div> 
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      documentExcel:"",
      imageEmpty: "",
      loader: false,
      users:[],
      user:"",
      userEmpty:false,
      roles:[],
      number:"",
      type:""
    };
  },
    mounted: function () {
      let queryParam = this.$route?.query?.type  
      this.type = queryParam
  },

  methods: {
        imageUpload(event) {
      this.documentExcel = event.target.files[0];
    },
        async getUsers() {
          if(this.number !== "" && this.number?.length > 3){
      this.loader = true;
      await axios
        .get(
          `${this.$store.getters.baseUrl}/get_nonebox_users?mobile=${this.number}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then(async (response) => {
          console.log(response);
          this.loader = false;
          if (response.data.status == "success") {
            this.users = await response.data.data;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
        }
    },

   async  getUser(id){
    await console.log('id', id);
      this.user = id
    },

    async save() {

     const formdata = new FormData();

     if(this.type == 'export'){
       formdata.append("import_excel", this.documentExcel);
      await axios
        .post(`${this.$store.getters.baseUrl}/import_users`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "EBox User added successfully", "success");
             this.$router.push({name: 'EBox User'});
            this.user = "";
            this.userEmpty = ""
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });

     }else{
      formdata.append("user_id", this.user);
      await axios
        .post(`${this.$store.getters.baseUrl}/ebox_create`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "EBox User added successfully", "success");
             this.$router.push({name: 'EBox User'});
            this.user = "";
            this.userEmpty = ""
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });

        }
    },
  },
  
};
</script>

